module.exports = __webpack_public_path__ + "img/ldp3.e6a67643.png";